import React from 'react'

import type { FindDriverData } from '../../../hooks/useFindDriver'
import { Dialog } from '../../Dialog'

import styles from './style.module.css'

type Props = {
  driverData: FindDriverData
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDriverModal: React.FC<Props> = ({ driverData, onConfirm, onCancel }) => (
  <Dialog
    onClose={onCancel}
    prevButtonProps={{
      label: 'キャンセル',
      onClick: onCancel,
      variant: 'cancel',
    }}
    nextButtonProps={{
      label: '更新する',
      onClick: onConfirm,
      variant: 'primary',
    }}
  >
    <p className={styles.message}>
      電話番号「{driverData.driverPhone}」は登録済みです。
      <br />
      ドライバー名「{driverData.driverName}」で更新しますか？
    </p>
  </Dialog>
)
